import React from 'react';
import { motion } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
interface FeatureCardProps {
  title: string;
  description: string;
  icon: BoxIcon;
  delay?: number;
}
export function FeatureCard({
  title,
  description,
  icon: Icon,
  delay = 0
}: FeatureCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} className="flex flex-col items-center text-center p-6 rounded-xl bg-gradient-to-br from-cyan-50 to-teal-50 border-2 border-cyan-200" data-id="element-116">
      <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-cyan-600 to-teal-600 text-white shadow-lg shadow-cyan-500/30" data-id="element-117">
        <Icon className="h-6 w-6" data-id="element-118" />
      </div>
      <h3 className="mb-2 text-lg font-serif font-bold text-slate-900" data-id="element-119">
        {title}
      </h3>
      <p className="text-slate-700 leading-relaxed" data-id="element-120">{description}</p>
    </motion.div>;
}